import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiItem\UpdateWikiItemController::__invoke
* @see app/Http/Controllers/WikiItem/UpdateWikiItemController.php
* @route '/api/wiki-items/{wiki_item}'
*/
const UpdateWikiItemController = (args: { wiki_item: number | { id: number } } | [wiki_item: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateWikiItemController.url(args, options),
    method: 'put',
})

UpdateWikiItemController.definition = {
    methods: ["put"],
    url: '/api/wiki-items/{wiki_item}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\WikiItem\UpdateWikiItemController::__invoke
* @see app/Http/Controllers/WikiItem/UpdateWikiItemController.php
* @route '/api/wiki-items/{wiki_item}'
*/
UpdateWikiItemController.url = (args: { wiki_item: number | { id: number } } | [wiki_item: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { wiki_item: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { wiki_item: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            wiki_item: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        wiki_item: typeof args.wiki_item === 'object'
        ? args.wiki_item.id
        : args.wiki_item,
    }

    return UpdateWikiItemController.definition.url
            .replace('{wiki_item}', parsedArgs.wiki_item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiItem\UpdateWikiItemController::__invoke
* @see app/Http/Controllers/WikiItem/UpdateWikiItemController.php
* @route '/api/wiki-items/{wiki_item}'
*/
UpdateWikiItemController.put = (args: { wiki_item: number | { id: number } } | [wiki_item: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateWikiItemController.url(args, options),
    method: 'put',
})

export default UpdateWikiItemController